import React from 'react';

import type { Nullable } from '@clearverify/types';

import { useVerifiersListQuery, VerifierOrderBy, VerifierWhere } from 'src/api';
import { PaginationQueryVariables } from 'src/hooks/common';

export const useVerifiers = (
  filter?: VerifierWhere,
  sort?: Nullable<VerifierOrderBy>,
  paginationVariables?: PaginationQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = useVerifiersListQuery({
    variables: {
      filter,
      orderBy: sort,
      ...paginationVariables,
    },
    notifyOnNetworkStatusChange,
  });

  const verifiersList = React.useMemo(() => {
    return data?.verifierList ?? [];
  }, [data?.verifierList]);

  const verifiersCount = React.useMemo(() => {
    return data?.verifierCount || 0;
  }, [data?.verifierCount]);

  return {
    verifiersList,
    verifiersCount,
    verifiersLoading: loading,
    refetch,
  };
};
